import { useSettings } from "@utilities/context/settings";
import { FC } from "react";
import { LOGIN_URL } from "../../constants/netlifyFunctionUrls";
import Cta from "../Cta/Cta";

export type Props = {
  returnUrlValue: string;
};

const GuestView: FC<Props> = ({ returnUrlValue }) => {
  const { siteSettings } = useSettings();
  const returnUrl = `${LOGIN_URL}?returnUrl=/${returnUrlValue}`;

  return (
    <div className="my-2">
      <div>
        <p>{siteSettings?.guestViewMessage}</p>
      </div>
      <div className="w-full md:w-100">
        <Cta
          url={returnUrl}
          linkText={siteSettings?.guestMessageCtaText}
          type="primary"
        />
      </div>
    </div>
  );
};

export default GuestView;
